import { createSlice } from '@reduxjs/toolkit';
import { IState, STATE } from '../types/state';
import { MAP_NAMES } from 'common/utils';
import { EMPTY_STRING } from 'common/constants';
import setLocale from './i18n/setLocale';
import initPage from './initPage';
import statusLoading from './statusLoading';
import setError from './setError';
import setSuccess from './setSuccess';
import getLocale from '../utils/getLocale';
import resetNotice from './resetNotice';

export const initialState: IState = {
  i18n: {
    locale: getLocale(),
  },
  isLoading: EMPTY_STRING,
  countries: [],
  roadsideService: [],
  stationCategories: [],
  serviceFormats: [],
  additionalParams: [],
  additionalServices: [],
  services: [],
  notice: null,
  activeMap: MAP_NAMES.yandex,
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setLocale,
    initPage,
    statusLoading,
    setSuccess,
    setError,
    resetNotice,
  },
});

export default slice;
